/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    variants: {
        notification: {
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 1,
            position: 'absolute',
            left: '37.5%',
            top: '37.5%',
            right: '-37.5%',
            bottom: '-37.5%',
            width: 'auto',
            height: 'auto',
            color: 'stokkeCore.white',
            fontSize: '0.625rem',
            fontWeight: 'semibold',
            lineHeight: '70%',
            backgroundColor: 'stokkeCore.black',
            borderRadius: 'full'
        }
    }
}
